import React, { FC } from "react";
import { CSSTransition } from "react-transition-group";
import "./PrintErrorToast.css";
import closeCircleIcon from "../../areas/cashless/nominalCashless/close-circle-line.svg";

interface PrintErrorToastProps {
  isOpen: boolean;
  onRetry: () => void;
  onSkip: () => void;
  message?: string;
}

export const PrintErrorToast: FC<PrintErrorToastProps> = ({
  isOpen,
  onRetry,
  onSkip,
  message = "Erro na impressão. Por favor, solicite suporte.",
}) => {
  const nodeRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      in={isOpen}
      timeout={500}
      classNames="print-error-modal"
      nodeRef={nodeRef}
    >
      <div className="PrintErrorToast" ref={nodeRef}>
        <div className="message-PrintErrorToast">
          <div className="icon-PrintErrorToast">
            <img src={closeCircleIcon} alt="Erro" />
          </div>
          <div className="text-PrintErrorToast">
            <span className="title">{message}</span>
            <span className="subtitle">
              Você pode tentar novamente ou pular esta impressão
            </span>
          </div>
          <div className="buttons-PrintErrorToast">
            <button className="retry-button" onClick={onRetry}>
              Tentar novamente
            </button>
            <button className="skip-button" onClick={onSkip}>
              Pular impressão
            </button>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};
